import base64 from 'base-64';
import EncodedExcelTemplates from './EncodedExcelTemplates';

const findExcelTemplate = reportName => base64.decode(EncodedExcelTemplates[reportName]);

export default findExcelTemplate;
